import { Exclude, Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';

export class WorkFlowWorkOrderLinkResultDto {
    workFlowId: number;
    invoiceNumber: string;
    invoiceAmount: number;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    invoiceDate: Date;

    vendorName: string;

    @Exclude()
    sortId: number;
}
